import { render, staticRenderFns } from "./SalesReservationB.vue?vue&type=template&id=43628db5&scoped=true&"
import script from "./SalesReservationB.vue?vue&type=script&lang=js&"
export * from "./SalesReservationB.vue?vue&type=script&lang=js&"
import style0 from "./SalesReservationB.vue?vue&type=style&index=0&id=43628db5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43628db5",
  null
  
)

export default component.exports